import React, { useState, useEffect, useRef, useContext } from "react";
import { LassieContext } from "../../context/LassieProvider";
import { Link, NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import { useBranding } from "../../branding/BrandingProvider";
import "./navbar.css";
import lassieIcon from "../../assets/img/LASSIE-LOGO-Green-Dog.png";
import lassieIconWhite from "../../assets/img/LASSIE-LOGO-White-Dog.png";

export default function Navbar() {
  const { windfarms } = useContext(LassieContext);
  const brand = useBranding();

  const navigate = useNavigate();

  let { windfarm_id } = useParams();
  const { pathname } = useLocation();
  // brand: a dropdown's parent link is active when any of its pages is open
  const portfolioActive = pathname === "/lassie" || pathname.startsWith("/lassie/windfarm");
  const historicActive =
    pathname.startsWith("/lassie/historic-lightning") || pathname.startsWith("/lassie/logbook");
  if (windfarm_id) {
    windfarm_id = parseInt(windfarm_id);
  }

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const sidebarRef = useRef(null);
  const iconRef = useRef(null);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        iconRef.current &&
        !iconRef.current.contains(event.target)
      ) {
        setIsSidebarOpen(false);
      }
    };

    if (isSidebarOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isSidebarOpen]);

  return (
    <>
      <div className="navbar-container">
        <div className="image-area">
          {brand.logo && <img
            className="nav-logo"
            alt={brand.name}
            src={brand.logo}
            onClick={() => {
              navigate("/");
            }}
          />}
          <img
            className="lassie-icon-header"
            src={lassieIcon}
            alt="LASSIE ICON"
            onClick={() => {
              navigate("/lassie");
            }}
          />
        </div>
        <div className="navigation-area">
          <NavLink to={`/`} end>Wind Diagnostics</NavLink>

          <div className="dropdown">
            <Link to={`/lassie`} className={portfolioActive ? "active" : ""}>Portfolio</Link>
            <div className={`nav-dropdown-arrow-icon`}></div>
            <div className="dropdown-content">
              {windfarms &&
                windfarms.map((w) => (
                  <NavLink key={w.id} to={`windfarm/${w.id}`}>
                    {w.name}
                  </NavLink>
                ))}
            </div>
          </div>

          <div className="dropdown">
            <span className={`nav-label ${historicActive ? "active" : ""}`}>Historic Data</span>
            <div className={`nav-dropdown-arrow-icon`}></div>
            <div className="dropdown-content">
              <NavLink
                to={`historic-lightning${
                  windfarm_id ? `/windfarm/${windfarm_id}` : ""
                }`}
              >
                Lightning Analysis
              </NavLink>
              <NavLink
                to={`logbook${windfarm_id ? `/windfarm/${windfarm_id}` : ""}`}
              >
                Logbook
              </NavLink>
            </div>
          </div>
          <NavLink
            to={`dashboard${windfarm_id ? `/windfarm/${windfarm_id}` : ""}`}
          >
            Dashboard
          </NavLink>
          <a
            href="https://weather.dtn.com/dtnweather/"
            target="_blank"
            rel="noopener noreferrer"
          >
            DTN Weather Sentry
          </a>
        </div>
        <div
          ref={sidebarRef}
          className={`sidebar ${isSidebarOpen ? "out" : ""}`}
        >
          <ul>
            <Link to="/lassie">
              <li>
                {" "}
                <div>Home</div>
              </li>
            </Link>
            <Link to="/lassie/settings/notifications">
              <li>
                {" "}
                <div>Settings</div>
              </li>
            </Link>
            {brand.showSupportContact && <Link to="/lassie/support">
              <li>
                <div>Support & FAQ</div>
              </li>
            </Link>}
            <Link to="/logout">
              <li>
                {" "}
                <div>Log out</div>
              </li>
            </Link>
          </ul>
          <div className="bottom-image">
            <img
              className="lassie-icon"
              src={lassieIconWhite}
              alt="LASSIE icon"
              onClick={() => {
                navigate("/lassie");
              }}
            />
          </div>
        </div>
        <div className="sidebar-area">
          <div
            ref={iconRef}
            className={`icon ${isSidebarOpen ? "out" : ""}`}
            onClick={toggleSidebar}
          >
            <div className="bar"></div>
            <div className="bar mdl"></div>
            <div className="bar"></div>
          </div>
        </div>
      </div>
    </>
  );
}
